import React from "react";
import Header from "../components/Header";
import { Link } from "react-router-dom";
import FAQ from "../components/FAQ";
import "../css/SafariPage.css";
import { Helmet } from "react-helmet-async";

import { faqData } from "../components/FAQ";

export default function JeepSafariPage() {

  const heroImage = "/images/jeep-hero.jpg";


  const faqSchema = {

    "@context": "https://schema.org",

    "@type": "FAQPage",

    "mainEntity": faqData.map(faq => ({

      "@type": "Question",

      "name": faq.question,

      "acceptedAnswer": {

        "@type": "Answer",

        "text": faq.answer

      }

    }))

  };

  return (
    <>

<Helmet>

  <title>
    Jeep Safari Ranthambore Booking | Zones, Timings & Guide
  </title>

  <meta
    name="description"
    content="Complete guide to Jeep Safari Ranthambore. Learn safari zones, timings, and booking information."
  />

  <link
    rel="canonical"
    href="https://safariranthamborebooking.com/jeep-safari-ranthambore"
  />

    <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>


</Helmet>

    
      <Header />

      {/* HERO SECTION */}
      <div
        className="safari-hero"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="safari-overlay">
              <div className="safari-overlay-canter-jii">
 <h1 > Jeep Safari Ranthambore – Complete Guide & Information</h1>
 <a href="/" className="bf-button-canter-ji">Plan Your Trip Now</a>

          </div>
        </div>
      </div>


      <div className="safari-container">


        {/* INTRO */}
        <div className="highlight-box">

          <h2>Experience Ranthambore National Park in Jeep Safari</h2>

          <p>
            Jeep Safari is the most popular and recommended safari in Ranthambore National Park.
            Each jeep accommodates 6 passengers and offers the best flexibility and tiger sighting opportunities.
          </p>

          <p>
            Jeep Safari provides access to all safari zones and allows closer wildlife viewing,
            making it ideal for wildlife photography and tiger sightings.
          </p>

        </div>


        {/* VEHICLE IMAGE */}
        <img
          src="/images/jeep-vehicle.jpg"
          className="section-image"
          alt="Jeep Safari Ranthambore"
        />

        <p className="image-caption">
          Gypsy Jeep used for safari in Ranthambore National Park
        </p>


        {/* INFO GRID */}
        <div className="info-grid">

          <div className="info-item">
            <strong>Vehicle Type</strong>
            <p>6-Seater Open Jeep (Gypsy)</p>
          </div>

          <div className="info-item">
            <strong>Safari Duration</strong>
            <p>3.5 Hours Approx</p>
          </div>

          <div className="info-item">
            <strong>Guide Included</strong>
            <p>Professional Forest Guide</p>
          </div>

          <div className="info-item">
            <strong>Best For</strong>
            <p>Tiger Sightings & Photography</p>
          </div>

        </div>


        {/* FOREST IMAGE */}
        <img
          src="/images/ranthambore-forest.jpg"
          className="section-image"
          alt="Ranthambore Forest"
        />

        <p className="image-caption">
          Dense forest and wildlife habitat in Ranthambore National Park
        </p>


        {/* SAFARI TIMINGS */}
        <div className="safari-section">

          <h2>Jeep Safari Timings</h2>

          <div className="safari-card">

            <ul>
              <li>Morning Safari: 6:30 AM – 10:00 AM</li>
              <li>Afternoon Safari: 2:30 PM – 6:00 PM</li>
              <li>Timings vary depending on season</li>
              <li>Safari duration is approximately 3.5 hours</li>
            </ul>

          </div>

        </div>


        {/* TIGER IMAGE */}
        <img
          src="/images/ranthambore-tiger.jpg"
          className="section-image"
          alt="Tiger Ranthambore Jeep Safari"
        />

        <p className="image-caption">
          Tiger sighting during Jeep Safari in Ranthambore
        </p>


        {/* ZONES */}
        <div className="safari-section">

          <h2>Safari Zones Covered</h2>

          <div className="safari-card">

            <p>
              Jeep Safari operates in all 10 safari zones of Ranthambore National Park.
              Zones 1 to 5 are core zones and offer higher tiger sighting probability.
            </p>

            <ul>
              <li>Zone 1 – Famous tiger territory</li>
              <li>Zone 2 – High wildlife movement</li>
              <li>Zone 3 – Popular lakes and tiger sightings</li>
              <li>Zone 4 – Scenic forest zone</li>
              <li>Zone 5 – Excellent tiger sightings</li>
              <li>Zone 6–10 – Buffer zones with wildlife</li>
            </ul>

          </div>

        </div>


        {/* ZONE MAP */}
        <div className="safari-section">

          <h2>Ranthambore Safari Zone Map</h2>

          <img
            src="/images/ranthambore-zone-map.jpg"
            className="section-image"
            alt="Ranthambore Zone Map"
          />

          <p className="image-caption">
            Map showing safari zones in Ranthambore National Park
          </p>

        </div>


        {/* GALLERY */}
        <div className="gallery-container">

          <h2>Jeep Safari Gallery</h2>

          <div className="gallery-slider">

            <img src="/images/jeep-gallery1.jpg" alt="Jeep Safari Ranthambore" />

            <img src="/images/jeep-gallery2.jpg" alt="Tiger Jeep Safari Ranthambore" />

            <img src="/images/jeep-gallery3.jpg" alt="Forest Jeep Safari" />

            <img src="/images/jeep-gallery4.jpg" alt="Wildlife Jeep Safari Ranthambore" />

          </div>

        </div>


        {/* FAQ */}
        <FAQ />


       


      </div>

    </>
  );
}
